import { defineStore } from "pinia";
import http from "../api/httpRequest.js";

/**
 * 接入会话 / 转接待办列表（多状态与接口 /customer/transfer/list 对齐）
 * 与 friendStore 类似：集中管理列表、角标与拉取逻辑，供 Chat、Home(WS) 共用。
 */
export default defineStore("pendingTransferStore", {
  state: () => ({
    /** status:1待接受 2已接受 3已拒绝 4已取消 */
    listCache: {
      1: [],
      2: [],
      3: [],
      4: []
    },
    listLoading: false
  }),
  getters: {
    /** 「接入会话」主 Tab 角标：待接受数量 */
    acceptBadgeCount: (state) => (state.listCache[1] || []).length,
    listForStatus: (state) => {
      return (status) => {
        const key = Number(status);
        return state.listCache[key] || [];
      };
    }
  },
  actions: {
    setListLoading(loading) {
      this.listLoading = loading;
    },
    setListForStatus(status, list) {
      const key = Number(status);
      if (!this.listCache[key]) {
        this.listCache[key] = [];
      }
      this.listCache[key] = Array.isArray(list) ? list.slice() : [];
    },
    /**
     * WS 推送待转接：写入待接受列表（status=1），去重
     * @param {object} payload 与列表项结构一致（含 id 或 transferId）
     */
    addPendingFromWebSocket(payload) {
      if (!payload || typeof payload !== "object") {
        return;
      }
      const rowId = payload.id != null ? payload.id : payload.transferId;
      if (rowId == null) {
        return;
      }
      const list = this.listCache[1] || [];
      const dup = list.some((i) => {
        const id = i.id != null ? i.id : i.transferId;
        return id != null && String(id) === String(rowId);
      });
      if (dup) {
        return;
      }
      this.listCache[1] = [payload, ...list];
    },
    /** 接受/拒绝/接口刷新后从各状态列表移除 */
    removePendingById(id) {
      if (id == null) {
        return;
      }
      [1, 2, 3, 4].forEach((k) => {
        const arr = this.listCache[k];
        if (!arr || !arr.length) {
          return;
        }
        const idx = arr.findIndex((i) => i.id === id || String(i.id) === String(id));
        if (idx > -1) {
          arr.splice(idx, 1);
        }
      });
    },
    clear() {
      this.listCache = { 1: [], 2: [], 3: [], 4: [] };
      this.listLoading = false;
    },
    /**
     * 拉取指定 status 的转接列表（与 friendStore.loadFriend 一样在 store 内发请求）
     * @param {string|number} status 1待接受 2已接受 3已拒绝 4已取消；默认 1
     */
    loadTransferList(status) {
      const s = status != null ? String(status) : "1";
      this.setListLoading(true);
      return http({
        url: "/customer/transfer/list",
        method: "GET",
        params: { status: s }
      })
        .then((res) => {
          this.setListForStatus(s, res);
        })
        .finally(() => {
          this.setListLoading(false);
        });
    },
    /** 登录后预拉「待接受」，用于角标（与 loadFriend 一起在 loadStore 里调用） */
    loadPendingAcceptList() {
      return this.loadTransferList(1);
    }
  }
});
